import { type CombinedMobileSidebarBox, type MobileSidebarBox } from 'AdmissionsGuidance';

export function isCombinedMobileSidebarBox(box: MobileSidebarBox): box is CombinedMobileSidebarBox {
    return 'primary' in box;
}
